import PaymentMtnBanner from "../assets/images/momo.png";
import PaymentMtnBannerPerson from "../assets/images/mtn-pay-banner.png";
const PublicImages = { PaymentMtnBanner, PaymentMtnBannerPerson };
export default PublicImages;
